
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ifko_p62i8_9",
  "disable-paddings": "awsui_disable-paddings_1ifko_p62i8_48",
  "main": "awsui_main_1ifko_p62i8_52",
  "actions": "awsui_actions_1ifko_p62i8_59",
  "content-wrap": "awsui_content-wrap_1ifko_p62i8_63",
  "wrap-actions": "awsui_wrap-actions_1ifko_p62i8_73",
  "content": "awsui_content_1ifko_p62i8_63"
};
  